import { render, staticRenderFns } from "./FileBlock.vue?vue&type=template&id=67755e84&scoped=true"
import script from "./FileBlock.vue?vue&type=script&lang=js"
export * from "./FileBlock.vue?vue&type=script&lang=js"
import style0 from "./FileBlock.vue?vue&type=style&index=0&id=67755e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67755e84",
  null
  
)

export default component.exports